(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-chapter"] && !Shopify.designMode) return;
  try {
    
  /* lab-video — the chapter's video block: muted, playsinline, preload none, a visible
     Riproduci / Pausa control. It plays only when pressed: DIRECTION §6, nothing on the
     site moves on its own (an "autoplay in view" option was removed on 2026-09-23).
     Listeners go with the element. */
  if (!customElements.get('lab-video')) {
    class LabVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.control = this.querySelector('[data-video-control]');
        if (!this.video || !this.control) return;
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.control.addEventListener('click', () => this.toggle(), { signal });
        this.video.addEventListener('play', () => this.reflect(), { signal });
        this.video.addEventListener('pause', () => this.reflect(), { signal });
        this.reflect();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
      }

      toggle() {
        if (this.video.paused) {
          this.video.play().catch(() => this.reflect());
        } else {
          this.video.pause();
        }
      }

      reflect() {
        const playing = !this.video.paused;
        this.control.textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        this.control.setAttribute('aria-pressed', String(playing));
      }
    }
    customElements.define('lab-video', LabVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-label-reproduction"] && !Shopify.designMode) return;
  try {
    
  /* lab-label-view — the label at a readable scale on a phone: the one .lr moves into the
     sheet on open and back on close (Esc, the Close button or the backdrop all end in
     `close`). Opening is a tap; nothing animates on its own. */
  if (!customElements.get('lab-label-view')) {
    class LabLabelView extends HTMLElement {
      connectedCallback() {
        this.label = this.querySelector('[data-label]');
        this.dialog = this.querySelector('dialog');
        // not `this.slot`: HTMLElement.slot is the element's own slot attribute, a string
        this.sheet = this.querySelector('[data-label-slot]');
        this.opener = this.querySelector('[data-label-open]');
        if (!this.label || !this.dialog || !this.sheet || !this.opener) return;
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.opener.addEventListener('click', () => this.open(), { signal });
        this.querySelector('[data-label-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('close', () => this.restore(), { signal });
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
      }

      open() {
        this.sheet.append(this.label);
        this.dialog.showModal();
        this.sheet.parentElement.focus();
      }

      restore() {
        this.prepend(this.label);
        this.opener.focus();
      }
    }
    customElements.define('lab-label-view', LabLabelView);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  // the sort select submits its own GET form on change. The form keeps its Ordina → submit
  // button: it is the no-script path, lab-section-search.css hides it visually only once
  // this element is :defined, and it comes back on :focus-visible for keyboard users.
  if (!customElements.get('lab-sort-form')) {
    customElements.define(
      'lab-sort-form',
      class LabSortForm extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          this.addEventListener(
            'change',
            (event) => {
              const select = event.target;
              if (!(select instanceof HTMLSelectElement) || !select.form) return;
              select.form.requestSubmit();
            },
            { signal: this.abort.signal }
          );
        }
        disconnectedCallback() {
          this.abort?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
